// Acoris-facing alias of the shared related-person / child-NIR helpers.
// The underlying logic is client-agnostic; this module keeps Acoris templates
// free of Miltis naming while reusing the single source of truth.
import {
  childHasSocialRegimeAttachmentMismatch,
  childNirIsManualEntry,
  childRequiresOffContractSpouseNir,
  childUsesStrictNirValidation,
  getAgeFromBirthDate,
  getNirInheritanceFromStored,
  hasChildSocialRegimeAttachmentMismatch,
  isChildLinkedToAdherent,
  isChildLinkedToSpouse,
  normalizeMiltisChildRelatedPerson,
  parentsHaveDifferentSocialRegimes,
  resolveChildInheritedNir,
  resolveChildLinkedParentRegime,
  resolveChildSocialRegimeForPricing,
  shouldAskChildrenSocialRegime,
} from "utils/helpers/miltisRelatedPersonChild";

export const normalizeAcorisChildRelatedPerson =
  normalizeMiltisChildRelatedPerson;

export {
  childHasSocialRegimeAttachmentMismatch,
  childNirIsManualEntry,
  childRequiresOffContractSpouseNir,
  childUsesStrictNirValidation,
  getAgeFromBirthDate,
  getNirInheritanceFromStored,
  hasChildSocialRegimeAttachmentMismatch,
  isChildLinkedToAdherent,
  isChildLinkedToSpouse,
  parentsHaveDifferentSocialRegimes,
  resolveChildInheritedNir,
  resolveChildLinkedParentRegime,
  resolveChildSocialRegimeForPricing,
  shouldAskChildrenSocialRegime,
};

const digitsOnly = (value) => String(value || "").replace(/\D/g, "");

export const childNirMatchesAttachmentParent = ({
  authority,
  childNir,
  adherentNir,
  spouseNir,
  nirInheritanceFrom,
}) => {
  const child = digitsOnly(childNir);
  if (!child) return false;
  if (
    isChildLinkedToAdherent({ authority, nirInheritanceFrom }) &&
    child === digitsOnly(adherentNir)
  ) {
    return true;
  }
  if (
    isChildLinkedToSpouse({
      authority,
      nirInheritanceFrom,
      hasSpouse: true,
    }) &&
    child === digitsOnly(spouseNir)
  ) {
    return true;
  }
  if (authority == null) {
    return child === digitsOnly(adherentNir) || child === digitsOnly(spouseNir);
  }
  return false;
};

export const shouldSoftValidateAcorisChildNir = ({
  authority,
  childNir,
  adherentNir,
  spouseNir,
  nirInheritanceFrom,
}) =>
  !childUsesStrictNirValidation(authority) ||
  childNirMatchesAttachmentParent({
    authority,
    childNir,
    adherentNir,
    spouseNir,
    nirInheritanceFrom,
  });
